import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { FaLinkedin } from 'react-icons/fa';
import { FaInstagram } from 'react-icons/fa6';

export function SiteFooter() {
  return (
    <footer className="bg-gsp-navy text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          <div>
            <h4 className="font-semibold text-white mb-4 uppercase tracking-wide text-sm">
              Los Angeles HQ
            </h4>
            <address className="not-italic text-[#A3C4D1] text-sm leading-relaxed">
              1900 Avenue of the Stars<br />
              Suite 250<br />
              Los Angeles, CA 90067
            </address>
            <a
              href="https://www.gspartners.com/contact/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 text-[#A3C4D1] hover:text-white text-sm mt-3 transition-colors"
            >
              All Locations <ArrowRight className="w-3 h-3" />
            </a>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-4 uppercase tracking-wide text-sm">
              New York HQ
            </h4>
            <address className="not-italic text-[#A3C4D1] text-sm leading-relaxed">
              650 Fifth Avenue<br />
              Suite 1100<br />
              New York, NY 10022
            </address>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-4 uppercase tracking-wide text-sm">
              Contact
            </h4>
            <div className="space-y-2 text-sm">
              <a
                href="tel:+13105578336"
                className="block text-[#A3C4D1] hover:text-white transition-colors"
              >
                (310) 557-8336
              </a>
              <a
                href="mailto:info@propvetter.com"
                className="block text-[#A3C4D1] hover:text-white transition-colors"
              >
                info@propvetter.com
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-4 uppercase tracking-wide text-sm">
              Explore
            </h4>
            <nav className="space-y-2 text-sm">
              <Link
                to="/consulting"
                className="block text-[#A3C4D1] hover:text-white transition-colors"
              >
                Advisory
              </Link>
              <a
                href="https://www.gspartners.com/about/"
                target="_blank"
                rel="noopener noreferrer"
                className="block text-[#A3C4D1] hover:text-white transition-colors"
              >
                About
              </a>
              <a
                href="https://www.gspartners.com/team/"
                target="_blank"
                rel="noopener noreferrer"
                className="block text-[#A3C4D1] hover:text-white transition-colors"
              >
                Team
              </a>
              <a
                href="https://www.gspartners.com/financings/"
                target="_blank"
                rel="noopener noreferrer"
                className="block text-[#A3C4D1] hover:text-white transition-colors"
              >
                Financings
              </a>
              <a
                href="https://www.gspartners.com/services/"
                target="_blank"
                rel="noopener noreferrer"
                className="block text-[#A3C4D1] hover:text-white transition-colors"
              >
                Services
              </a>
            </nav>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-4 uppercase tracking-wide text-sm">
              Follow Us
            </h4>
            <div className="flex gap-3">
              <a
                href="https://www.linkedin.com/company/propvetter/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-gsp-teal flex items-center justify-center hover:bg-gsp-orange transition-all duration-300"
                aria-label="Propvetter on LinkedIn"
              >
                <FaLinkedin className="w-4 h-4" />
              </a>
              <a
                href="https://www.instagram.com/georgesmithpartners/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-gsp-teal flex items-center justify-center hover:bg-gsp-orange transition-all duration-300"
                aria-label="Instagram"
              >
                <FaInstagram className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-gsp-navy-light">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-[#A3C4D1] text-sm">
              &copy; 2026 George Smith Partners, Inc. All Rights Reserved.
            </p>
            <div className="flex items-center gap-4">
              <Link
                to="/terms"
                className="text-[#A3C4D1] hover:text-white text-sm transition-colors"
              >
                Terms of Service
              </Link>
              <a
                href="https://www.gspartners.com/privacy/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#A3C4D1] hover:text-white text-sm transition-colors"
              >
                Privacy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default SiteFooter;
